import { useTranslation } from "react-i18next";

const cards = [
  {
    key: "card1",
    icon: "ri-file-list-3-line",
    img: "https://readdy.ai/api/search-image?query=A%20tablet%20and%20smartphone%20on%20a%20clean%20desk%20showing%20colorful%20organized%20spreadsheet%20grids%2C%20soft%20mint%20and%20cream%20tones%2C%20gentle%20natural%20daylight%2C%20minimal%20editorial%20tech%20photography%2C%20high%20detail%2C%20no%20readable%20text&width=600&height=400&seq=value-spreadsheet-01&orientation=landscape"
  },
  {
    key: "card2",
    icon: "ri-star-line",
    img: "https://readdy.ai/api/search-image?query=A%20neat%20arrangement%20of%20five%20star%20rating%20cards%20and%20a%20handwritten%20review%20note%20on%20a%20warm%20beige%20surface%2C%20soft%20golden%20light%2C%20minimal%20editorial%20photography%2C%20high%20detail%2C%20no%20readable%20text&width=600&height=400&seq=value-reviews-02&orientation=landscape"
  },
  {
    key: "card3",
    icon: "ri-truck-line",
    img: "https://readdy.ai/api/search-image?query=A%20stack%20of%20neatly%20sealed%20cardboard%20shipping%20boxes%20with%20a%20paper%20tag%20on%20a%20light%20blue%20studio%20floor%2C%20soft%20even%20lighting%2C%20clean%20minimal%20logistics%20photography%2C%20high%20detail%2C%20no%20text&width=600&height=400&seq=value-shipping-03&orientation=landscape"
  },
  {
    key: "card4",
    icon: "ri-scan-line",
    img: "https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20over%20a%20folded%20garment%20on%20a%20sage%20green%20inspection%20table%2C%20bright%20even%20lighting%2C%20clean%20quality%20control%20product%20photography%2C%20high%20detail%2C%20no%20text&width=600&height=400&seq=value-qc-04&orientation=landscape"
  },
  {
    key: "card5",
    icon: "ri-shield-check-line",
    img: "https://readdy.ai/api/search-image?query=A%20shield%20symbol%20with%20a%20padlock%20resting%20on%20a%20soft%20pastel%20pink%20studio%20surface%2C%20soft%20warm%20lighting%2C%20minimal%20security%20concept%20photography%2C%20clean%20fresh%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=400&seq=value-safety-05&orientation=landscape"
  },
];

export default function ValueSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-2xl text-foreground-950 md:text-4xl">{t("value.title")}</h2>
          <p className="mt-3 text-base text-foreground-600">{t("value.subtitle")}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {cards.map((c) => (
            <div
              key={c.key}
              className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-transform hover:-translate-y-1"
            >
              <div className="h-40 w-full overflow-hidden">
                <img
                  src={c.img}
                  alt={t(`value.${c.key}.title`)}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="p-6">
                <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                  <i className={`text-lg ${c.icon}`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 text-base font-bold text-foreground-950">{t(`value.${c.key}.title`)}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t(`value.${c.key}.text`)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}